import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M564.706 1581.177H338.824V338.824h1242.353v225.882h-112.942V451.765H451.765v1016.47h112.941v112.942zM0 0h1242.353v225.882h-112.941v-112.94H112.941v1016.47h112.941v112.94H0V0zm847.059 1920H677.647v-169.412h112.942v56.471h56.47V1920zm180.662 0v-112.941h180.662V1920h-180.662zm361.433 0v-112.941h180.662V1920h-180.662zm530.846 0h-169.412v-112.941h56.471v-56.471H1920V1920zm-112.941-711.508v-180.661H1920v180.661h-112.941zm0 361.435v-180.662H1920v180.662h-112.941zM1920 847.059h-112.941v-56.47h-56.471V677.647H1920v169.412zm-892.169-56.471V677.647h180.661v112.941h-180.661zm361.434 0V677.647h180.662v112.941h-180.662zm-598.677 56.47h-112.94V677.648h169.41v112.942h-56.47v56.47zm-112.941 361.325v-180.662h112.941v180.662H677.647zm0 361.433v-180.662h112.941v180.662H677.647z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBlueprintSolid =
/*#__PURE__*/
function (_Component) {
  _inherits(IconBlueprintSolid, _Component);

  function IconBlueprintSolid() {
    _classCallCheck(this, IconBlueprintSolid);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconBlueprintSolid).apply(this, arguments));
  }

  _createClass(IconBlueprintSolid, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBlueprint",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBlueprintSolid.displayName = "IconBlueprintSolid";
  return IconBlueprintSolid;
}(Component);

IconBlueprintSolid.glyphName = 'blueprint';
IconBlueprintSolid.variant = 'Solid';
IconBlueprintSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBlueprintSolid;
export { IconBlueprintSolid };